import GroupsSelectList from './GroupsSelectList';

export default GroupsSelectList;
